import { render, staticRenderFns } from "./GoalRecord.vue?vue&type=template&id=851ff294&"
import script from "./GoalRecord.vue?vue&type=script&lang=js&"
export * from "./GoalRecord.vue?vue&type=script&lang=js&"
import style0 from "./GoalRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports